import { BaseEntity } from "yt-ng-framework";

export class OsobaTelefon extends BaseEntity{
    constructor(){
        super();
    }

    OsobaID: number = null;
    Glavni:boolean = null;
    VrstaTelefonaID:number = null;
    Broj:string = null;
    Lokal:string = null;
    SvojinaID:number = null;
    Opis:string = null;

    Deserialize(input:any){
        this.ID=input.ID;
        this.OsobaID=input.OsobaID;
        this.Glavni=input.Glavni;
        this.VrstaTelefonaID=input.VrstaTelefonaID;
        this.Broj=input.Broj;
        this.Lokal=input.Lokal;
        this.SvojinaID=input.SvojinaID;
        this.Opis=input.Opis;
        return this;
    }

    Serialize(input:OsobaTelefon){
        return input;
    }
}